"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseShortcutsModule = /** @class */ (function () {
    function FuseShortcutsModule() {
    }
    return FuseShortcutsModule;
}());
exports.FuseShortcutsModule = FuseShortcutsModule;
